module.exports = __webpack_public_path__ + "media/images/pet-avatar-e4c263a78aba7e28ea13366e12d8009f.png";